import { AgreeCheckBox, IAgreeCheckBoxProps } from './AgreeCheckBox';
import { FormAction, IFormActionProps } from './FormAction';
import { FormFields, IFormField } from './FormFields';

export interface IFormSectionProps {
  agreeCheckBox?: IAgreeCheckBoxProps;
  formActions?: IFormActionProps;
  formFields?: IFormField[];
}

/**
 * -----------------------------------------------------------------------------
 * It renders agree checkbox, form buttons and form fields
 */
export function FormSection({
  agreeCheckBox,
  formActions,
  formFields,
}: Readonly<IFormSectionProps>) {
  return (
    <div className="px-4 py-1">
      {formFields ? <FormFields fields={formFields} /> : null}
      {agreeCheckBox ? <AgreeCheckBox {...agreeCheckBox} /> : null}
      {formActions ? <FormAction {...formActions} /> : null}
    </div>
  );
}
